// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2vDp8","content":"LoadingAlert_content__UEoTU"};